 const getBaseURL = () => {     const currentHost = window.location.hostname; 
    if (currentHost.startsWith('www.')) {
        return 'https://www.comprepopularlr.com/';
    } else {
        return 'https://www.comprepopularlr.com/';
    }
    
};

const baseURL = getBaseURL(); 

export default baseURL;

